export class DataGridSort {
    public name: string;
    public order: string;

    constructor(dataGridSort?: DataGridSort) {
        this.name = dataGridSort && dataGridSort.name || null;
        this.order = dataGridSort && dataGridSort.order || null;
    }
}
